import React, { useEffect, useState } from 'react'

import { EditOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons'
import { Avatar, Descriptions, Divider, Popover, Upload, Typography, Modal } from 'antd'

import { Link } from 'react-router-dom'

import { Container } from './styled'
import { useLogic, Itens } from '../../context/useLogic'

import cley from '../../assets/img/cley.jpg'

const { Paragraph } = Typography

const DropUser: React.FC = () => {
  const { itens } = useLogic()

  const [userLogado, setUserLogado] = useState<Itens>({} as Itens)
  const [visibleEditPerfil, setVisibleEditPerfil] = useState(false)

  useEffect(() => {
    if (itens[0]) {
      itens[0].nome = itens[0]?.nome?.toLowerCase()

      if (itens[0].email === 'cley@vegatecnologia.com.br') {
        itens[0].doc_foto_perfil = cley
      } else {
        itens[0].doc_foto_perfil = null
      }

      setUserLogado(itens[0])
    }
  }, [])

  return (
    <Container>
      <Popover
        placement='bottomRight'
        trigger='click'
        content={
          <div className='popover-content-user'>
            <ul>
              <li>
                <Avatar src={userLogado.doc_foto_perfil}>
                  {String(userLogado.nome).substring(0, 1).toLocaleUpperCase()}
                </Avatar>
                {'   '}
                <span>
                  <span className='capitalized'>{String(userLogado.nome)}</span>
                </span>
              </li>
              <Divider style={{ margin: '8px 0 8px 0' }} />
              <li>
                <a onClick={() => setVisibleEditPerfil(true)} href='#'>
                  <EditOutlined /> <span>Editar Perfil</span>
                </a>
              </li>
              <li>
                <a href='#'>
                  <SettingOutlined /> <span>Configuraçoes</span>
                </a>
              </li>
              <li>
                <a href='/logout'>
                  <LogoutOutlined /> <span>Sair</span>
                </a>
              </li>
            </ul>
          </div>
        }
      >
        <Link to='#'>
          <Avatar size='large' src={userLogado.doc_foto_perfil}>
            {String(userLogado.nome).substring(0, 1).toLocaleUpperCase()}
          </Avatar>
        </Link>
      </Popover>

      <Modal open={visibleEditPerfil} onCancel={() => setVisibleEditPerfil(false)} title='Perfil'>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <Upload>
            <Avatar
              draggable
              src={userLogado.doc_foto_perfil}
              size='large'
              style={{
                width: '80px',
                height: '80px',
                textAlign: 'center',
                paddingTop: userLogado.doc_foto_perfil === null ? '15px' : null,
                cursor: 'pointer',
              }}
            >
              <span
                style={{
                  fontSize: '60px',
                  top: '16px',

                }}
              >
                {String(userLogado.nome).substring(0, 1).toLocaleUpperCase()}
              </span>
            </Avatar>
          </Upload>
          <Descriptions style={{ width: '100%' }} column={1} size='small' title='Dados do usuario'>
            <Descriptions.Item className='capitalized' label='Nome'>
              <Paragraph style={{ width: '100%', textAlign: 'left' }} editable>
                {String(userLogado.nome)}
              </Paragraph>
            </Descriptions.Item>
            <Descriptions.Item label='Email'>
              <Paragraph>{String(userLogado.email)}</Paragraph>
            </Descriptions.Item>
          </Descriptions>
        </div>
      </Modal>
    </Container>
  )
}

export default DropUser
